<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Herr+Von+Muellerhoff&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

    .signature-container {

        .printed {
            margin-bottom: 20px;
            font-size: 1.2em;
            font-weight: bold;
        }

        .signature {
            padding: 0px 15px 5px 15px;
            font-size: 40pt;
            font-family: 'Yellowtail', cursive;
        }

        .meta {
            margin-top: 25px;

        }

    }
</style>

<template>
    <div class="signature-container">
        <div class="printed">Signed By: {{ name }}</div>
        <div class="signature">{{ name }}</div>
        <div class="meta">On: {{ date | moment('MM/DD/YYYY h:mm a') }}</div>
    </div>
</template>

<script>
    export default {
        name: "PrintableSignature",
        props: ['name', 'date'],
    }
</script>
